export default __webpack_public_path__ + "static/media/logoWildCatDark.82ce36da.png";